import { Link } from 'react-router-dom';

type LogoProps = {
  size?: 'sm' | 'md' | 'lg';
  withWordmark?: boolean;
  className?: string;
};

const sizes = {
  sm: { svg: 16, text: 'text-base' },
  md: { svg: 22, text: 'text-xl' },
  lg: { svg: 28, text: 'text-2xl' },
};

/**
 * Stacked violet+cyan prism + lowercase wordmark — locked from canvas #652.
 * Used pixel-identically across nav and footer.
 */
export default function Logo({ size = 'md', withWordmark = true, className = '' }: LogoProps) {
  const { svg, text } = sizes[size];
  return (
    <Link to="/" className={`inline-flex items-center gap-2 group ${className}`}>
      <svg
        width={svg}
        height={svg}
        viewBox="0 0 32 32"
        fill="none"
        aria-label="Pryma logo"
        className="transition-transform duration-200 group-hover:rotate-[-4deg]"
      >
        <path d="M11 4 L21 26 L1 26 Z" fill="#7C3AED" />
        <path d="M14 8 L22 26 L6 26 Z" fill="#06B6D4" />
      </svg>
      {withWordmark && (
        <span className={`${text} font-bold tracking-tighter text-ink`}>pryma.</span>
      )}
    </Link>
  );
}
